import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SystemData } from "./system-data";
import { HttpResponsesHandlersFactory, BaseDataService, IHttpResponseHandlerSettings } from "../data-service";
import { Version } from "./version";

@Injectable({
    providedIn: "root"
})
export class SystemDataService extends BaseDataService {
    readonly url = "api/system-data";
    systemData: Promise<SystemData>;

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getData(): Promise<SystemData> {
        if (!this.systemData) {
            this.systemData = this.handleRequest<SystemData>(
                this.http.get<SystemData>(this.url),
                this.handlersFactory.getForReadByFilter()
            );
        }

        return this.systemData;
    }

    getVersionInfo(responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<Version> {
        return this.handleRequest<Version>(this.http.get<Version>(`${this.url}/version`), this.handlersFactory.getDefault(responseHandlerSettings));
    }

    getDebugData(): Promise<any> {
        return this.handleRequest(this.http.get(`${this.url}/debug`), this.handlersFactory.getDefault());
    }

    getApiExceptionsData(): Promise<any> {
        return this.handleRequest(this.http.get(`${this.url}/debug/api-exeptions`), this.handlersFactory.getDefault());
    }
}